import Konva from 'konva';
import { schemeColorsMap } from '../../constant/constants';
import { convertNumber } from './fenceCalculatorUtils';

const firstDistance = 1;
const tubeHeight = 6;
const halfTubeHeight = 3;

// const clampHeightMap = {
//   1: 20,
//   2: 30,
//   3: 40,
//   4: 50,
//   5: 60,
//   6: 70
// };

export class FenceDiagramScheme {
  bgColor = '#ffeeaa';
  clampHeight;
  clampWidth = 12;
  fenceInfo;
  canvasOriginalHeight;
  canvasOriginalWidth;
  coordinateOffset = 40;
  connectionSize = 10; // affects connetor size
  connectionHalfSize;
  containerHeight;
  containerWidth;
  oneInX;
  oneInY;
  field;
  layer;
  serifOffset = 3; // affects marks on axes and arrows
  stage;
  eave_length = 10;
  isEveLengthLargerThanGraphLength = false;

  constructor({ bgColor, containerId, containerHeight, containerWidth, fenceInfo, onFinish }) {
    this.bgColor = bgColor;
    this.fenceInfo = fenceInfo;
    this.isEveLengthLargerThanGraphLength = fenceInfo?.eave_length > 60;
    this.eave_length = this.isEveLengthLargerThanGraphLength ? 60 : fenceInfo?.eave_length;
    this.containerHeight = containerHeight;
    this.containerWidth = containerWidth;
    this.field = this.containerHeight - this.coordinateOffset * 2;
    this.connectionHalfSize = this.connectionSize / 2;
    // this.clampHeight = fenceInfo?.tube_system ? (fenceInfo?.tube_system + 1) * 10 : 10;
    this.clampHeight = 20;

    const { canvasHeight, canvasWidth, oneInX, oneInY } = this.getSizes();

    this.canvasOriginalHeight = canvasHeight;
    this.canvasOriginalWidth = canvasWidth;
    this.oneInX = oneInX;
    this.oneInY = oneInY;

    const stage = new Konva.Stage({
      container: containerId,
      height: this.containerHeight,
      width: this.containerWidth,
      draggable: true
    });

    const layer = new Konva.Layer();
    layer.offsetY(stage.height());
    layer.scaleY(-1);
    stage.add(layer);

    const shift = this.coordinateOffset * 10;
    const bgRect = new Konva.Rect({
      x: -shift,
      y: -shift,
      width: canvasWidth + shift * 2,
      height: canvasHeight + shift * 2,
      fill: schemeColorsMap.grey[300]
    });
    layer.add(bgRect);

    this.stage = stage;
    this.layer = layer;

    this.drawAxis();
    this.drawFence();

    onFinish(
      this.stage.toDataURL({
        x: 0,
        y: this.containerHeight - this.canvasOriginalHeight - this.coordinateOffset * 2,
        width: this.canvasOriginalWidth + this.coordinateOffset * 2,
        height: this.canvasOriginalHeight + this.coordinateOffset * 2
      })
    );

    let newScale = 1;

    stage.on('dragmove', () => {
      //let currentCanvasWidth = canvasWidth * newScale;
      const pos = this.stage.position();

      // if (-pos.x < 0) {
      //   pos.x = 0;
      // } else if (
      //   -pos.x + this.containerWidth >
      //   currentCanvasWidth + this.coordinateOffset * 2
      // ) {
      //   pos.x =
      //     -currentCanvasWidth + this.containerWidth - this.coordinateOffset * 2;
      // }

      // if (pos.y < 0) {
      //   pos.y = 0;
      // } else if (
      //   pos.y + this.containerHeight >
      //   canvasHeight + this.coordinateOffset * 2
      // ) {
      //   pos.y = canvasHeight - this.containerHeight + this.coordinateOffset * 2;
      // }

      stage.position(pos);
    });

    const scaleBy = 1.2;
    const maxScale = 3;
    const minScale = 0.1;
    stage.on('wheel', (e) => {
      e.evt.preventDefault();

      const oldScale = stage.scaleX();
      const pointer = stage.getPointerPosition();

      if (!pointer) return null;

      const mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale
      };

      let direction = e.evt.deltaY > 0 ? 1 : -1;

      if (e.evt.ctrlKey) {
        direction = -direction;
      }

      newScale = -direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

      if (newScale > maxScale) {
        newScale = maxScale;
      }

      if (newScale < minScale) {
        newScale = minScale;
      }

      stage.scale({ x: newScale, y: newScale });
      const newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale
      };
      stage.position(newPos);
    });
  }
  /**
   * to draw both axes and label text (value) on there edges
   */
  drawAxis() {
    const group = new Konva.Group();

    const bottomArrowWidth = this.canvasOriginalWidth + this.coordinateOffset;
    const topArrowHeight = this.canvasOriginalHeight;

    [
      // horizontal axis line
      {
        moveToStart: this.coordinateOffset,
        moveToEnd: this.coordinateOffset,
        lineToStart: this.coordinateOffset,
        lineToEnd: bottomArrowWidth
      },
      // bootom arrow head lower line
      {
        moveToStart: this.coordinateOffset,
        moveToEnd: bottomArrowWidth,
        lineToStart: this.coordinateOffset - this.serifOffset,
        lineToEnd: bottomArrowWidth - this.coordinateOffset / 2
      },
      // bootom arrow head upper line
      {
        moveToStart: this.coordinateOffset,
        moveToEnd: bottomArrowWidth,
        lineToStart: this.coordinateOffset + this.serifOffset,
        lineToEnd: bottomArrowWidth - this.coordinateOffset / 2
      },
      // vertical axis line
      {
        moveToStart: this.coordinateOffset - 1,
        moveToEnd: this.coordinateOffset,
        lineToStart: topArrowHeight,
        lineToEnd: this.coordinateOffset
      },
      // top arrow head left line
      {
        moveToStart: topArrowHeight,
        moveToEnd: this.coordinateOffset,
        lineToStart: topArrowHeight - this.coordinateOffset / 2,
        lineToEnd: this.coordinateOffset - this.serifOffset
      },
      // top arrow head right line
      {
        moveToStart: topArrowHeight,
        moveToEnd: this.coordinateOffset,
        lineToStart: topArrowHeight - this.coordinateOffset / 2,
        lineToEnd: this.coordinateOffset + this.serifOffset
      }
    ].forEach(({ lineToEnd, lineToStart, moveToEnd, moveToStart }) => {
      const line = new Konva.Line({
        points: [lineToEnd, lineToStart, moveToEnd, moveToStart],
        stroke: schemeColorsMap.black,
        strokeWidth: 2
      });
      group.add(line);
    });

    // values (labels) part below *****************************

    [
      // vertical axis top vaue text
      {
        x: this.coordinateOffset / 4,
        y: 0,
        value: `${Math.min(this.fenceInfo?.length_of_panel, 60)}'` // max label is set to 60
      },
      // horizontal axis top vaue text
      {
        x: bottomArrowWidth,
        y: topArrowHeight - this.coordinateOffset + this.coordinateOffset / 4,
        value: `${this.eave_length}'`
      }
    ].forEach(({ value, x, y }) => {
      const text = new Konva.Text({
        x: x,
        y: topArrowHeight - y,
        text: value,
        fontSize: 14,
        fontFamily: 'serif',
        fill: 'black',
        align: 'center'
      });
      text.scaleY(-1);
      group.add(text);
    });
    this.layer.add(group);
  }

  /**
   * Claculates the the total number of row where max vertical distance is 60 feet
   *
   * @returns number of rows
   */
  getMaxRows() {
    const firstDistance = this.fenceInfo?.distance_first;
    const secondDistance = this.fenceInfo?.distance_second;
    const numberOfFences = this.fenceInfo?.number_fence;
    if (!firstDistance || !secondDistance || !numberOfFences) return 1;
    let totalRows = numberOfFences;
    let totalDistance = firstDistance + secondDistance;
    // const scaledTotalDistance = totalDistance * (this.oneInY)
    const maxDistance = 60; // 60 * 12 =720
    for (let n = 3; n <= numberOfFences; n++) {
      if (totalDistance < maxDistance) {
        totalRows = n;
        totalDistance += secondDistance;
      } else {
        break;
      }
    }
    return totalRows;
  }

  drawFence() {
    // Check if there's anything to draw
    if (!this.fenceInfo?.clamp_deck_list?.qty) return;

    let isFirstLine = true;
    const group = new Konva.Group();
    // to make sure proper number of clamps on graph if eve length is grater than 60
    // we need scaling factor
    const scalingFactor = this.eave_length / this.fenceInfo?.eave_length;
    // const rows = this.fenceInfo?.number_fence; // current understadning: rows
    const rows = this.getMaxRows(); // current understadning: rows
    // no of clampsPerRow per row
    const clampsPerRow = (this.fenceInfo?.clamp_deck_list.qty / rows) * scalingFactor;
    const clampSpacing = this.canvasOriginalWidth / (clampsPerRow + 1); //space b/w clampsPerRow
    // 1/2 width of clamp - to draw line at center
    const halfClampWidth = Math.round(this.clampWidth / 2);
    // const spacingBtwnTubes = this.clampHeight / (this.fenceInfo?.tube_system + 1); // tube line
    const spacingBtwnTubes = this.clampHeight / 2; // tube line
    const minTubes = this.eave_length / 10;
    // const tubes = Math.ceil(minTubes);

    const lastTubeSizeLabel = (minTubes - Math.floor(minTubes)) * 10;
    // const tubesLength = tubes <= 1 ? 2 : tubes * 2;
    const tubesLength = 6;

    const tubeMaxSize = 120;
    const rightCoordinate = this.coordinateOffset + this.canvasOriginalWidth; // most right co-ord.
    const yTubeSize = this.coordinateOffset + (firstDistance * this.oneInY) / 2;

    const calculateRowDistance = (rowIndex) => {
      if (rowIndex == 0) return firstDistance; // distanse of first fence
      if (rowIndex == 1) return firstDistance + this.fenceInfo?.distance_first; // for second fence
      return (
        firstDistance +
        this.fenceInfo?.distance_first +
        (rowIndex - 1) * this.fenceInfo?.distance_second // for third and additional fences
      );
    };

    const drawClamps = (rowDistance) => {
      for (let i = 1; i <= clampsPerRow; i++) {
        const x = this.coordinateOffset + i * clampSpacing - halfClampWidth;
        const y = this.coordinateOffset + rowDistance * this.oneInY;
        group.add(
          new Konva.Rect({
            x,
            y,
            width: this.clampWidth,
            height: this.clampHeight,
            fill: schemeColorsMap.grey[300],
            stroke: schemeColorsMap.black
          })
        );
      }
    };

    // number of rows
    for (let i = 0; i < rows; i++) {
      const distance = calculateRowDistance(i);
      // draw tubes
      // new Array(1)?.fill(1)?.forEach((_, index) => {
      const y = Math.round(this.coordinateOffset + spacingBtwnTubes * 1 + distance * this.oneInY);

      if (clampsPerRow && tubesLength > 1) {
        for (let j = 1; j < tubesLength; j++) {
          // if j is 1 or divisible by 5
          if (j === 1 || !(j % 5)) {
            const startX =
              this.coordinateOffset + (j === 1 ? j - 1 : j) * tubeMaxSize * this.oneInX;
            const endX =
              this.coordinateOffset + (j + (j === 1 ? 4 : 5)) * tubeMaxSize * this.oneInX;
            const right = endX > rightCoordinate ? rightCoordinate : endX - this.connectionHalfSize;

            // if j is not 1
            j !== 1 &&
              [
                [
                  startX + this.connectionHalfSize,
                  yTubeSize + this.serifOffset * 2,
                  startX + this.connectionHalfSize,
                  yTubeSize - this.serifOffset * 2
                ]
              ].forEach((points) => {
                group.add(
                  new Konva.Line({
                    points,
                    stroke: schemeColorsMap.black,
                    strokeWidth: 1
                  })
                );
              });

            [
              [
                endX - this.connectionHalfSize,
                yTubeSize + this.serifOffset * 2,
                endX - this.connectionHalfSize,
                yTubeSize - this.serifOffset * 2
              ]
            ].forEach((points) => {
              group.add(
                new Konva.Line({
                  points,
                  stroke: schemeColorsMap.black,
                  strokeWidth: 1
                })
              );
            });
            //tube
            // group.add(
            //   new Konva.Line({
            //     points: [
            //       j === 1 ? startX : startX + this.connectionHalfSize,
            //       y,
            //       right,
            //       y,
            //     ],
            //     stroke: schemeColorsMap.black,
            //     strokeWidth: 1,
            //   })
            // );

            // draw tubes ///////////////////////////////////////////
            const x = j === 1 ? startX + 5 : startX + this.connectionHalfSize;
            // to prevent any negative value
            if (right - x >= 0 && y - halfTubeHeight >= 0) {
              group.add(
                new Konva.Rect({
                  x,
                  y: y - halfTubeHeight,
                  width: right - x,
                  height: tubeHeight,
                  stroke: 'black',
                  strokeWidth: 1,
                  cornerRadius: 20
                })
              );

              // horizondal line at 1'
              group.add(
                new Konva.Line({
                  points: [
                    j === 1 ? startX : startX + this.connectionHalfSize,
                    yTubeSize,
                    right,
                    yTubeSize
                  ],
                  stroke: schemeColorsMap.grey[200],
                  strokeWidth: 1
                })
              );
            }
          }

          // if j is not divisble by 5
          if (j % 5) {
            const xCoord = this.coordinateOffset + j * tubeMaxSize * this.oneInX;
            if (!i && !0) {
              // connector's below vertical line
              group.add(
                new Konva.Line({
                  points: [xCoord, y, xCoord, yTubeSize],
                  stroke: schemeColorsMap.grey[200],
                  strokeWidth: 1
                })
              );

              // inclined dash line at bottom end of connector's vertical line
              group.add(
                new Konva.Line({
                  points: [
                    xCoord - this.serifOffset,
                    yTubeSize - this.serifOffset,
                    xCoord + this.serifOffset,
                    yTubeSize + this.serifOffset
                  ],
                  stroke: schemeColorsMap.grey[200],
                  strokeWidth: 1
                })
              );

              const text = new Konva.Text({
                x: xCoord - (tubeMaxSize * this.oneInX) / 2,
                y: yTubeSize + 15,
                text: `10'`,
                fontSize: 14,
                fontFamily: 'serif',
                fill: 'black',
                align: 'center'
              });
              text.scaleY(-1);
              text.offsetX(text.width() / 2);
              group.add(text);

              if (!((j + 1) % 5)) {
                const text = new Konva.Text({
                  x:
                    this.coordinateOffset +
                    (j + 1) * tubeMaxSize * this.oneInX -
                    (tubeMaxSize * this.oneInX) / 2,
                  y: yTubeSize + 15,
                  text: `10'`,
                  fontSize: 14,
                  fontFamily: 'serif',
                  fill: 'black',
                  align: 'center'
                });
                text.scaleY(-1);
                text.offsetX(text.width() / 2);
                group.add(text);
              }
            }

            // conncetors (boxes)
            group.add(
              new Konva.Rect({
                x: xCoord - this.connectionHalfSize,
                y: y - this.connectionHalfSize + halfTubeHeight - 2,
                width: this.connectionSize,
                height: tubeHeight + 2,
                fill: schemeColorsMap.black,
                stroke: schemeColorsMap.black,
                strokeWidth: 1,
                cornerRadius: 1
              })
            );
          }

          // label
          if (j + 1 === tubesLength && isFirstLine) {
            isFirstLine = false;
            const xCoord = this.coordinateOffset + j * tubeMaxSize * this.oneInX;
            const rightCoordinate = this.canvasOriginalWidth + this.coordinateOffset;

            const text = new Konva.Text({
              x: xCoord + (rightCoordinate - xCoord) / 2,
              y: yTubeSize + 15,
              text: `${
                Number.isInteger(lastTubeSizeLabel || 10)
                  ? lastTubeSizeLabel || 10
                  : lastTubeSizeLabel.toFixed(2)
              }'`,
              fontSize: 14,
              fontFamily: 'serif',
              fill: 'black',
              align: 'center'
            });
            text.scaleY(-1);
            text.offsetX(text.width() / 2);
            group.add(text);
          }
        }
      }
      // });

      // lines showing columns and passing through clampsPerRow
      drawClamps(distance);
    }

    // column lines passing through clamps vertically
    for (let j = 1; j <= clampsPerRow; j++) {
      const x = Math.round(this.coordinateOffset + j * clampSpacing);
      group.add(
        new Konva.Line({
          points: [x, this.coordinateOffset, x, this.canvasOriginalHeight],
          stroke: schemeColorsMap.grey[100],
          strokeWidth: 1
        })
      );
    }

    // inclinde dashes under 1st three clamps
    if (clampsPerRow > 1) {
      for (let i = 1; i <= (clampsPerRow >= 2 ? 3 : 2); i++) {
        const spacing = i * clampSpacing;
        const x = Math.round(this.coordinateOffset + spacing);
        group.add(
          new Konva.Line({
            points: [
              x - this.serifOffset,
              this.coordinateOffset - this.serifOffset,
              x + this.serifOffset,
              this.coordinateOffset + this.serifOffset
            ],
            stroke: schemeColorsMap.black,
            strokeWidth: 1
          })
        );

        // label
        if (i !== 1) {
          const text = new Konva.Text({
            x: x - clampSpacing / 2,
            y: this.coordinateOffset - 10,
            text: `${convertNumber(this.fenceInfo?.width_of_panel, 8)}''`,
            fontSize: 14,
            fontFamily: 'serif',
            fill: 'black',
            align: 'center'
          });
          text.scaleY(-1);
          text.offsetX(text.width() / 2);
          group.add(text);
        }
      }
    }

    const distanceMap = {
      0: firstDistance,
      1: this.fenceInfo?.distance_first,
      2: this.fenceInfo?.distance_second
    };

    // dashes and labels on y axis
    [firstDistance, this.fenceInfo?.distance_first, this.fenceInfo?.distance_second]
      .slice(0, rows > 2 ? 3 : rows > 1 ? 2 : 1)
      .forEach((distance, index) => {
        const currentDistance = !index
          ? firstDistance
          : index > 1
            ? firstDistance + this.fenceInfo?.distance_first + this.fenceInfo?.distance_second
            : firstDistance + this.fenceInfo?.distance_first;
        const y = this.coordinateOffset + currentDistance * this.oneInY + this.clampHeight / 2;
        // inclined dashes on y axis
        group.add(
          new Konva.Line({
            points: [
              this.coordinateOffset - this.serifOffset,
              y - this.serifOffset,
              this.coordinateOffset + this.serifOffset,
              y + this.serifOffset
            ],
            stroke: schemeColorsMap.black,
            strokeWidth: 1
          })
        );

        // label on y axis
        const shift = !index
          ? (firstDistance * this.oneInY) / 2
          : index > 1
            ? (this.fenceInfo?.distance_second / 2) * this.oneInY
            : (distance * this.oneInY) / 2;

        const text = new Konva.Text({
          x: this.coordinateOffset / 4,
          y: y - shift,
          text: `${distanceMap[index]}'`,
          fontSize: 14,
          fontFamily: 'serif',
          fill: 'black',
          align: 'center'
        });

        text.scaleY(-1);
        group.add(text);
      });

    this.layer.add(group);
  }

  getClampCoordinates({ coordX, coordY, oneInX, oneInY }) {
    return {
      graphCoordX: Math.round(this.coordinateOffset + 10 + coordX * oneInX),
      graphCoordY: Math.round(this.coordinateOffset + 10 + coordY * oneInY)
    };
  }

  getSizes() {
    // Factors that control how much the dimensions are scaled
    let scaleY = 1;
    let scaleX = 1;
    // counters
    let upCount = 0;
    let downCount = 0;
    // Control the spacing between elements in the layout
    let horizSpacing = this.fenceInfo?.width_of_panel;
    let verticalSpacing =
      this.fenceInfo?.distance_first > 100
        ? this.fenceInfo?.distance_first / 20
        : this.fenceInfo?.distance_first / 10;

    if (this.fenceInfo?.number_fence === 1) {
      verticalSpacing = 1;
    }

    let currentHeight = this.fenceInfo?.length_of_panel * 12;
    let currentWidth = this.isEveLengthLargerThanGraphLength ? 60 * 12 : this.eave_length * 12;
    const maxHorizSpacing = Infinity;
    const minHorizSpacing = this.fenceInfo?.width_of_panel * 4;
    const maxVertSpacing = 20;
    const minVertSpacing = 5;
    const maxCount = 50;

    /**
     * Downscaling
     *
     * Reduce the size (scale down) if the fence dimensions exceed the container dimensions,
     * while also ensuring the spacing doesn't violate the maximum spacing constraints.
     */
    while (
      // The height exceeds the container height and vertical spacing is larger than allowed
      // Or, the width exceeds the container width and horizontal spacing is larger than allowed
      (currentHeight / scaleY > this.containerHeight && verticalSpacing > maxVertSpacing) ||
      (currentWidth / scaleX > this.containerWidth && horizSpacing > maxHorizSpacing)
    ) {
      if (downCount > maxCount) {
        break;
      }

      // If the height is too large
      if (
        currentHeight / (scaleY * 1.5) > this.containerHeight &&
        verticalSpacing > maxVertSpacing
      ) {
        verticalSpacing /= 1.5; // Vertical spacing is reduced
        scaleY *= 1.5; // Vertical scaling is increased
      }

      // If the width is too large
      if (currentWidth / (scaleX * 1.5) > this.containerWidth && horizSpacing > maxHorizSpacing) {
        horizSpacing /= 1.5; // Horizontal spacing is reduced
        scaleX *= 1.5; // Horizontal scaling is increased
      }

      downCount++;
    }

    /**
     * Upscaling
     *
     * Increase the size (scale up)
     * if the fence dimensions are too small or the spacing violates the minimum constraints
     */
    while (
      // The height is smaller than the container height
      currentHeight / scaleY < this.containerHeight ||
      // Or the width is smaller than the container width
      currentWidth / scaleX < this.containerWidth ||
      // Or the vertical spacing is smaller than the minimum allowed
      verticalSpacing < minVertSpacing ||
      // Or the horizontal spacing is smaller than the minimum allowed
      horizSpacing < minHorizSpacing
    ) {
      if (upCount > maxCount) {
        break;
      }

      // If the height is too small or vertical spacing is insufficient
      if (currentHeight / scaleY < this.containerHeight || verticalSpacing < minVertSpacing) {
        scaleY /= 1.25; // Vertical scaling is decreased
        verticalSpacing *= 1.25; // Vertical spacing is increased
      }

      // If the width is too small or horizontal spacing is insufficient
      if (currentWidth / scaleX < this.containerWidth || horizSpacing < minHorizSpacing) {
        scaleX /= 1.25; // Horizontal scaling is decreased (to enlarge the width)
        horizSpacing *= 1.25; // Horizontal spacing is increased (to meet the minimum spacing)
      }

      upCount++;
    }
    currentHeight =
      this.fenceInfo?.number_fence === 1 // if there is only one fence
        ? this.containerHeight // is set to match this.containerHeight directly
        : //If there are multiple fences
          // Math.max: Ensures that the calculated height respects both the container
          // and the additional adjustments
          Math.max(
            this.containerHeight,
            this.coordinateOffset * 4 +
              //set max distance to 60 ft
              Math.min(
                (firstDistance +
                  // Adds a fixed distance specific to the first fence
                  this.fenceInfo?.distance_first +
                  // Adds the cumulative distance for all subsequent fences after the first
                  this.fenceInfo?.distance_second * (this.fenceInfo?.number_fence - 2)) *
                  // Scales the total height by the current vertical scaling factor (scaleY)
                  // This adjusts the calculated height to match the scaling applied earlier
                  (1 / scaleY),
                60 * (1 / scaleY)
              )
          );

    return {
      canvasHeight: currentHeight,
      canvasWidth: currentWidth / scaleX,
      oneInX: 1 / scaleX,
      oneInY: 1 / scaleY
    };
  }

  setInitPositions() {
    this.stage.scale({ x: 1, y: 1 });
    this.stage.position({
      x: 0,
      y: 0
    });
  }

  updateScene() {
    this.stage.batchDraw();
  }
}
